import React, { FC } from 'react';
import { Theme, Svg } from 'styled';
import { Color } from 'styled/theme/colors';

type Props = {
  className?: string;
  color: Color;
};

const FacebookIcon: FC<Props> = ({ className = '', color = 'white' }) => (
  <Svg
    width="28px"
    height="29px"
    viewBox="0 0 28 29"
    className={className}
    fill="transparent"
  >
    <desc>Facebook Icon.</desc>
    <path
      d="M27.5 14.3899C27.5 21.8457 21.4558 27.8899 14 27.8899C6.54416 27.8899 0.5 21.8457 0.5 14.3899C0.5 6.93405 6.54416 0.889893 14 0.889893C21.4558 0.889893 27.5 6.93405 27.5 14.3899Z"
      stroke={Theme.colors[color]}
    />
    <mask
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="10"
      y="8"
      width="7"
      height="14"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.374 8.17065H16.8299V21.0825H10.374V8.17065Z"
        fill={Theme.colors[color]}
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2807 21.0825C12.2818 21.0509 12.2839 21.0193 12.2839 20.9877C12.2841 19.0807 12.2841 17.1737 12.2841 15.2666V15.1937H12.2058H10.4567C10.3757 15.1937 10.3754 15.1936 10.3754 15.1123C10.3753 14.3985 10.3762 13.6847 10.374 12.9709C10.3738 12.9057 10.3928 12.8894 10.4534 12.8896C11.0364 12.8918 11.6194 12.8909 12.2024 12.8909H12.2841C12.2841 12.8661 12.284 12.8441 12.2841 12.822C12.2851 12.2286 12.2806 11.6351 12.2888 11.0417C12.2955 10.5644 12.3838 10.1023 12.5835 9.66912C12.8546 9.08104 13.2798 8.66075 13.8583 8.41017C14.245 8.24264 14.6494 8.16444 15.066 8.17104C15.5434 8.17854 16.0207 8.20082 16.498 8.21872C16.5867 8.2221 16.675 8.23783 16.7638 8.24253C16.8132 8.24517 16.8298 8.26434 16.8295 8.31587C16.8277 8.61149 16.8287 8.90717 16.8287 9.20285C16.8287 9.55132 16.8274 9.89974 16.8299 10.2482C16.8304 10.3089 16.8137 10.3274 16.7549 10.3269C16.3925 10.3244 16.03 10.3198 15.6678 10.3284C15.5033 10.3323 15.3363 10.351 15.1756 10.3878C14.8655 10.4588 14.682 10.6726 14.6203 10.9942C14.5954 11.1236 14.5813 11.2573 14.5801 11.3892C14.5754 11.8727 14.5781 12.3563 14.5782 12.84C14.5782 12.8544 14.5799 12.8689 14.5812 12.8909H14.6603C15.3284 12.8909 15.9964 12.8909 16.6645 12.8909C16.7521 12.8909 16.7534 12.8913 16.7426 12.9777C16.6953 13.358 16.6464 13.7381 16.5995 14.1184C16.5604 14.4361 16.5222 14.754 16.4858 15.072C16.4719 15.1934 16.4747 15.1937 16.3578 15.1937C15.7909 15.1937 15.2241 15.1938 14.6573 15.1938H14.578V15.2855C14.578 17.1714 14.5781 19.0573 14.578 20.9432C14.578 20.9896 14.577 21.0361 14.5765 21.0825H12.2807Z"
        fill={Theme.colors[color]}
      />
    </g>
  </Svg>
);

export default FacebookIcon;
